<template>
  <div id="app" v-if="isRouterAlive">
    <topNav></topNav>
    <router-view />
    <pageFooter></pageFooter>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRouterAlive: true
    };
  },
  name: "App",
  methods: {},
  mounted() {}
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
  width: 100%;
  font-size: 16px;
  /* user-select: none; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue